import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

export default function ZeroCostEstimateSection() {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");

  const handlerPostContact = async () => {
    if (!name || !phone) {
      Swal.fire({
        title: "기본 정보를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    // setLoading(true);

    await axios
      .post("/api/contact/quick", {
        name: name,
        phone: phone,
        type: "중간",
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        // setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };
  return (
    <div className="relative w-full h-full px-2 lg:px-[calc((100%-var(--container))/2)] mx-auto pb-14 lg:pb-28 xl:pb-36 text-center">
      <div className="relative w-full h-full max-w-screen-lg mx-auto px-4">
        <div className="lg:flex gap-4 lg:justify-between px-5 border-t border-b py-4 grid">
          {/* 왼쪽 문구 */}
          <div className="shrink-0 text-center lg:text-left">
            <p className="text-2xl leading-none text-primary tracking-[-0.12em]">
              미해결시 비용 ZERO<span className="italic font-bold">!</span>
            </p>
            <p className="mt-1 text-2xl leading-none text-black tracking-[-0.1em]">
              출장견적 요청하기
            </p>
          </div>

          {/* 입력폼 */}
          <div className="lg:flex gap-2 grid">
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="이름"
              className="h-[58px] w-full lg:w-1/2 rounded-md bg-gray-100 text-center text-lg  outline-none focus:ring-2 focus:ring-primary"
            />

            <input
              value={phone}
              onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ""))}
              placeholder="연락처"
              inputMode="numeric"
              maxLength={11}
              className="h-[58px] rounded-md bg-gray-100 text-center text-lg  outline-none focus:ring-2 focus:ring-primary"
            />

            <button
              type="button"
              onClick={handlerPostContact}
              className="h-[58px] rounded-md bg-primary px-8 text-2xl font-black text-point "
            >
              전송하기
            </button>
          </div>
        </div>

        {/* 하단 카피 */}
        <div className="my-10 text-center">
          <h2 className="gbold text-[30px] font-black leading-tight tracking-[-0.08em] text-secondary xs:text-[34px] sm:text-[38px] lg:text-[52px]">
            타업체&nbsp;실패현장도{" "}
            <span className="text-[#296bef]">100%&nbsp;해결</span>
            &nbsp;가능!
          </h2>

          <p className="mt-2 leading-snug sm:text-xl lg:text-2xl  tracking-[-0.08em]">
            365일&nbsp;24시간{" "}
            <span className="text-primary">서울·경기·인천 전지역</span>{" "}
            어디든지&nbsp;불러주시면
            <br className="hidden sm:block" />
            <span className="text-secondary">
              누수업계 최고의 인력이&nbsp;
              <span className="text-red">긴급출동</span>합니다
            </span>
          </p>
        </div>
        <div className=" grid lg:grid-cols-2 gap-5 xl:px-12">
          <div
            data-aos="fade-right"
            className="relative w-full h-full bg-light rounded-lg p-5 lg:pt-8"
          >
            <img
              src="/images/process1.png"
              alt="전화 상담 후 현장방문 견적 예약 안내"
              className="!relative w-full h-auto max-w-52 mx-auto object-contain"
            />
            <p className="mt-5 text-xl xl:text-2xl tracking-tighter">
              간단한 전화상담 후<br />
              <span className="text-[#296bef]">현장방문 견적 예약</span>을
              잡아주세요
            </p>
          </div>
          <div
            data-aos="fade-left"
            className="relative w-full h-full bg-light rounded-lg p-5 lg:pt-8"
          >
            <img
              src="/images/process2.png"
              alt="누수 기사 현장 긴급출동 안내"
              className="!relative w-full h-auto max-w-52 mx-auto object-contain"
            />
            <p className="mt-5 text-xl xl:text-2xl tracking-tighter">
              상시 준비중인 기사님께서
              <br />
              <span className="text-[#296bef]">현장으로 바로 긴급출동</span>
              합니다
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
